import { buildingActionTypes } from './building.types';

const initialState = {
  buildingName: '',
  buildingLocation: '',
  year: 'None',
  floors: 1,
  entrances: 1,
  insulationThickness: 'None',
  isRenovated: false,
  isInsulated: false,
  isAccessible: true,
  stairway: true,
  entranceOrientation: 'None',
};

//incraments number of floors and entrances (Existing geometry page)
const incrament = (state, action) => {
  const currentNum = state[action.payload];
  if (currentNum >= 9) {
    return { ...state, [action.payload]: state[action.payload] };
  }
  return { ...state, [action.payload]: state[action.payload] + 1 };
};

//decraments number of floors and entrances (Existing geometry page)
const decrament = (state, action) => {
  const currentNum = state[action.payload];
  if (currentNum <= 1) {
    return { ...state, [action.payload]: state[action.payload] };
  }
  return { ...state, [action.payload]: state[action.payload] - 1 };
};

const buildingReducer = (state = initialState, action) => {
  switch (action.type) {
    case buildingActionTypes.SET_BUILDING_NAME:
      return { ...state, buildingName: action.payload };
    case buildingActionTypes.SET_BUILDING_LOCATION:
      return { ...state, buildingLocation: action.payload };
    case buildingActionTypes.INCRAMENT:
      return incrament(state, action);
    case buildingActionTypes.DECRAMENT:
      return decrament(state, action);
    case buildingActionTypes.SET_YEAR:
      return { ...state, year: action.payload };
    case buildingActionTypes.SET_ORIENTATION:
      return { ...state, entranceOrientation: action.payload };
    case buildingActionTypes.CHECK_ITEM:
      return { ...state, [action.payload]: true };
    case buildingActionTypes.UNCHECK_ITEM:
      return { ...state, [action.payload]: false };
    case buildingActionTypes.EDIT_BUILDING:
      return { ...action.data };
    case buildingActionTypes.RESET_INSULATION:
      return { ...state, insulationThickness: 'None' };
    case buildingActionTypes.SELECT_PANELS_NUM:
      return { ...state, [action.text]: action.value };
    case buildingActionTypes.RESET_BUILDING:
      return { ...initialState };
    default:
      return state;
  }
};

export default buildingReducer;
